import { extractErrorMessage } from '../utils';

export function detectValidationRules(script, ownerFieldKey, allFieldKeys = []) {
  if (!script) return [];
  const rules = [];

  const isFutureCheck = (
    /can.t be of future/i.test(script) ||
    script.includes("date < cDate") ||
    script.includes("lossDate < cDate") ||
    script.includes("reportedDate < cDate") ||
    script.includes("policyEffectiveDate < cDate")
  );

  if (isFutureCheck) {
    const message = extractErrorMessage(script);
    rules.push({ rule: 'maxDate', value: 'today', message });
  }

  const isGteCheck = (
    /after or equal to loss date/i.test(script) ||
    /lossDate <= reportedDate/i.test(script) ||
    /startDate.*endDate/i.test(script)
  );

  if (isGteCheck) {
    const message = /after or equal to loss date/i.test(script)
      ? "Reported date should be after or equal to loss date."
      : extractErrorMessage(script);

    const compareTo = resolveCompareToField(script, ownerFieldKey, allFieldKeys);

    rules.push({
      rule: 'gte',
      compareTo: compareTo ?? 'lossdate_datetime_*',
      message,
    });
  }

  const isPolicyExpirationCheck = /greater than Policy Effective Date/i.test(script);
  if (isPolicyExpirationCheck) {
    const message = extractErrorMessage(script);
    const compareTo = findFieldKeyByPrefix('policyeffectivedate_datetime_', allFieldKeys)
      ?? 'policyeffectivedate_datetime_*';
    rules.push({ rule: 'gte', compareTo, message });
  }

  if (rules.length === 0 && script.trim().length > 0) {
    rules.push({
      rule: 'legacy',
      rawScript: script,
      message: 'Validation failed.',
    });
  }

  return rules;
}

function resolveCompareToField(script, ownerFieldKey, allFieldKeys) {
  const callMatch = script.match(
    /verifyValidations\([^,]+,\s*\$\(\s*["']\[id\^=([\w_]+)\]["']\s*\)\.val\(\)/
  );
  if (callMatch) {
    const prefix = callMatch[1];
    return findFieldKeyByPrefix(prefix, allFieldKeys) ?? `${prefix}*`;
  }
  return null;
}

function findFieldKeyByPrefix(prefix, allFieldKeys) {
  const found = allFieldKeys.find(key => key.startsWith(prefix));
  return found ?? null;
}
